// Procedural honeycomb fan anchored to the top-right corner: large empty outlines thinning out along a quarter-ellipse.
const R = 58;
const HH = Math.sqrt(3) * R;
const RX = 1100;
const RY = 820;
const W = RX + R;
const H = RY + R;
const COLS = Math.ceil(W / (1.5 * R)) + 1;
const ROWS = Math.ceil(H / HH) + 1;
const rnd = (i, j, k = 0) => { const x = Math.sin(i * 12.9898 + j * 78.233 + k * 37.719) * 43758.5453; return x - Math.floor(x); };
const hex = (cx, cy, r) => [0, 1, 2, 3, 4, 5].map((k) => { const a = (Math.PI / 3) * k; return `${(cx + r * Math.cos(a)).toFixed(1)},${(cy + r * Math.sin(a)).toFixed(1)}`; }).join(" ");

const cells = [];
for (let c = 0; c < COLS; c++) {
  for (let r = 0; r < ROWS; r++) {
    const cx = W - R - 1.5 * R * c;
    const cy = HH * r + (c % 2 ? HH / 2 : 0);
    const d = Math.hypot((W - cx) / RX, cy / RY) + (rnd(c, r) - 0.5) * 0.12;
    if (d > 1) continue;
    if (d > 0.45 && rnd(c, r, 1) < (d - 0.45) / 0.55 * 0.85) continue;
    cells.push({ key: `${c}-${r}`, cx, cy, o: Math.max(0.05, 0.3 * (1 - d * 0.85)) });
  }
}

export function HexField({ className = "" }) {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className={`pointer-events-none select-none ${className}`} aria-hidden data-testid="hex-field">
      {cells.map(({ key, cx, cy, o }) => (
        <polygon key={key} points={hex(cx, cy, R - 3)} fill="none" stroke="#E2CB92" strokeOpacity={o} strokeWidth="1.2" strokeLinejoin="round" />
      ))}
    </svg>
  );
}
